import { LABEL } from '@veriables';

export const TableHead = [
  {
    isSort: true,
    sortKey: 'stationNumberForSort',
    key: 'stationName',
    name: LABEL().CHECK_LISTING_TABLE_NUMBER,
  },
  {
    isSort: true,
    sortKey: 'numberForSort',
    key: 'number',
    name: LABEL().CHECK_LISTING_CHECK_NUMBER,
  },
  {
    isSort: true,
    prefix: `${LABEL().CURRENCY_SYMBOL}`,
    sortKey: 'paidAmount',
    key: 'paidAmount',
    name: LABEL().CHECK_LISTING_PAID,
  },
  {
    isSort: true,
    prefix: `${LABEL().CURRENCY_SYMBOL}`,
    sortKey: 'unpaidAmount',
    key: 'unpaidAmount',
    name: LABEL().CHECK_LISTING_DUE,
  },
  {
    isSort: false,
    prefix: '',
    sortKey: '',
    key: 'actions',
    name: '',
  },
];

export const TableRowActionButtons = [
  {
    name: LABEL().ORDER,
    key: 'order',
    style: { background: '#2541a4' },
  },
  {
    name: LABEL().PAY,
    key: 'pay',
    style: { background: '#028604' },
  },
  {
    name: LABEL().PRINT,
    key: 'print',
  },
  {
    name: LABEL().RECEIPT,
    key: 'receipt',
  },
  {
    name: LABEL().TOOLS,
    key: 'tools',
    style: { background: '#74a4ff' },
  },
];
